import {type TestIdProps, testIdProps} from '@github-ui/test-id-props'
import type {Icon} from '@primer/octicons-react'
import {Heading} from '@primer/react'
import {clsx} from 'clsx'

import styles from './automation-block.module.css'

type AutomationBlockProps = {
  icon?: Icon
  iconBg?: string
  iconColor?: string
  headerDescription?: string
  headerEnd?: React.ReactNode
  children?: React.ReactNode
} & TestIdProps

export const AutomationBlock = ({
  icon: Icon,
  iconBg,
  iconColor,
  headerDescription,
  headerEnd,
  children,
  ...props
}: AutomationBlockProps) => {
  return (
    <div className={styles.automationBlock} {...testIdProps('automation-block')} {...props}>
      <div className={styles.blockInner}>
        <div className={clsx(styles.blockHeader, children && styles.blockHeaderWithChildren)}>
          {Icon && (
            <div
              style={{
                backgroundColor: iconBg,
                color: iconColor,
              }}
              className={styles.iconContainer}
            >
              <Icon />
            </div>
          )}
          {headerDescription && (
            <Heading as="h3" className={styles.headerDescription}>
              {headerDescription}
            </Heading>
          )}
          {headerEnd ? <div className={styles.headerEnd}>{headerEnd}</div> : null}
        </div>
        {children ? <div className={styles.blockContent}>{children}</div> : null}
      </div>
    </div>
  )
}
